/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SignatureDtoBase
 * auto generated base class for the model SignatureDtoModel.
 */
export const SignatureDtoModelBase = ModelBase
  .named('SignatureDto')
  .props({
    __typename: types.optional(types.literal("SignatureDto"), "SignatureDto"),
    name: types.union(types.undefined, types.null, types.string),
    base64Png: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SignatureDtoModelSelector extends QueryBuilder {
  get name() { return this.__attr(`name`) }
  get base64Png() { return this.__attr(`base64Png`) }
}
export function selectFromSignatureDto() {
  return new SignatureDtoModelSelector()
}

export const signatureDtoModelPrimitives = selectFromSignatureDto().name.base64Png
